export const nonPermissionSidebarItems = [
  {
    key: 'dashboard',
    path: '/',
    label: 'SIDEBAR.DASHBOARD',
    icon: 'Dashboard',
    permission: ['dashboard'],
    sub_menu: [],
  },
  {
    key: 'profile',
    path: '/profile',
    label: 'SIDEBAR.PROFILE',
    icon: 'AccountBox',
    permission: ['profile'],
    sub_menu: [],
  },
];
export const staffSidebarItems = [
  {
    label: 'STAFF_SIDEBAR.MANAGE_ACCOUNTS.TITLE',
    icon: 'PersonAdd',
    permission: ['staff_users', 'staff_business_registrations'],
    sub_menu: [
      {
        key: 'staff_users',
        path: '/staff/manage-accounts',
        label: 'STAFF_SIDEBAR.MANAGE_ACCOUNTS.TITLE',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_business_registrations',
        path: '/staff/manage-accounts/approve-request',
        label: 'STAFF_SIDEBAR.MANAGE_ACCOUNTS.APPROVE_REQUEST',
        icon: 'SwapHorizontalCircle',
        read_permissions: ['staff_business_registrations.read'],
      },
      {
        key: 'staff_business_registrations',
        path: '/staff/manage-accounts/approve-history',
        label: 'STAFF_SIDEBAR.MANAGE_ACCOUNTS.APPROVE_HISTORY',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_users',
        path: '/staff/online-monitor',
        label: 'STAFF_SIDEBAR.MANAGE_ACCOUNTS.ONLINE_MONITOR',
        icon: 'SwapHorizontalCircle',
      },
    ],
  },
  {
    label: 'STAFF_SIDEBAR.DISTRIBUTOR.TITLE',
    icon: 'People',
    permission: ['staff_agent_tiers', 'staff_discounts'],
    sub_menu: [
      {
        key: 'staff_agent_tiers',
        path: '/distributor',
        label: 'STAFF_SIDEBAR.DISTRIBUTOR.TITLE',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_discounts',
        path: '/distributor/discount-configuration',
        label: 'STAFF_SIDEBAR.DISTRIBUTOR.DISCOUNT_CONFIGURATION',
        icon: 'SwapHorizontalCircle',
      },
    ],
  },
  {
    key: 'staff_suppliers',
    path: '/supplier',
    label: 'STAFF_SIDEBAR.SUPPLIER_LIST',
    is_under: false,
    icon: 'Business',
    permission: ['staff_suppliers'],
    sub_menu: [],
  },
  {
    key: 'staff_games',
    path: '/game-list',
    label: 'STAFF_SIDEBAR.GAME_LIST',
    is_under: false,
    icon: 'Storefront',
    permission: ['staff_games'],
    sub_menu: [],
  },
  // {
  //   key: 'staff_game_servers',
  //   path: '/server-list',
  //   label: 'STAFF_SIDEBAR.SERVER_LIST',
  //   is_under: false,
  //   icon: 'Storage',
  //   permission: ['staff_game_servers'],
  //   sub_menu: [],
  // },
  {
    label: 'STAFF_SIDEBAR.PACKAGE_LIST',
    icon: 'Inventory',
    permission: ['staff_game_packages', 'staff_discounts'],
    sub_menu: [
      {
        key: 'staff_game_packages',
        path: '/package',
        label: 'STAFF_SIDEBAR.PACKAGE_LIST',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_discounts',
        path: '/package/markup',
        label: 'STAFF_SIDEBAR.PACKAGE_MARKUP',
        icon: 'SwapHorizontalCircle',
      },
    ],
  },
  {
    label: 'STAFF_SIDEBAR.CREDIT_WALLET',
    icon: 'AccountBalanceWallet',
    permission: ['staff_transactions', 'staff_dashboard_credit_operations'],
    sub_menu: [
      {
        key: 'staff_transactions',
        path: '/credit-wallet',
        label: 'STAFF_SIDEBAR.CREDIT_WALLET',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_dashboard_credit_operations',
        path: '/transaction-all/customer-credit-transactions',
        label: 'STAFF_SIDEBAR.TRANSACTION_ALL.CUSTOMER_CREDIT_TRANSACTIONS',
        icon: 'SwapHorizontalCircle',
        read_permissions: ['staff_dashboard_credit_operations.read'],
      },
      {
        key: 'staff_transactions',
        path: '/credit-wallet/pending-review',
        label: 'STAFF_SIDEBAR.PENDING_REVIEW_TOPUPS',
        icon: 'HourglassEmpty',
      },
    ],
  },
  {
    key: 'staff_qr_monitor',
    path: '/sms-monitor',
    label: 'STAFF_SIDEBAR.SMS_MONITOR',
    is_under: false,
    icon: 'Notifications',
    permission: ['staff_qr_monitor'],
    sub_menu: [],
  },
  {
    key: 'staff_orders',
    path: '/staff/bot-monitor',
    label: 'STAFF_SIDEBAR.BOT_MONITOR',
    is_under: false,
    icon: 'SmartToy',
    permission: ['staff_orders'],
    sub_menu: [],
  },
  {
    label: 'STAFF_SIDEBAR.TRANSACTION_ALL.TITLE',
    icon: 'SwapHorizontalCircle',
    permission: ['staff_dashboard_credit_operations', 'staff_orders'],
    sub_menu: [
      {
        key: 'staff_dashboard_credit_operations',
        path: '/transaction-all',
        label: 'STAFF_SIDEBAR.TRANSACTION_ALL.DASHBOARD',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_orders',
        path: '/transaction-all/topup-transactions',
        label: 'STAFF_SIDEBAR.TRANSACTION_ALL.CUSTOMER_TOPUP_TRANSACTIONS',
        icon: 'SwapHorizontalCircle',
        read_permissions: ['staff_orders.read'],
      },
    ],
  },
  {
    key: 'staff_line_notify_targets',
    path: '/line-notify-targets',
    label: 'STAFF_SIDEBAR.LINE_NOTIFY_TARGETS',
    is_under: false,
    icon: 'Notifications',
    permission: ['staff_line_notify_targets'],
    sub_menu: [],
  },
  {
    key: 'staff_system_settings',
    path: '/settings',
    label: 'STAFF_SIDEBAR.SETTINGS',
    is_under: false,
    icon: 'Settings',
    permission: ['staff_system_settings'],
    read_permissions: ['staff_system_settings.read'],
    sub_menu: [],
  },
  {
    key: 'staff_reports',
    path: '/reports',
    label: 'STAFF_SIDEBAR.REPORT',
    icon: 'ListAlt',
    permission: ['staff_reports'],
    sub_menu: [
      {
        key: 'staff_reports',
        path: '/reports/topup',
        label: 'STAFF_SIDEBAR.REPORT_TOPUP',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_reports',
        path: '/reports/p2w',
        label: 'STAFF_SIDEBAR.REPORT_P2W',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_reports',
        path: '/reports/garena',
        label: 'STAFF_SIDEBAR.REPORT_GARENA',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'staff_reports',
        path: '/reports/profit-overview',
        label: 'STAFF_SIDEBAR.REPORT_PROFIT_OVERVIEW',
        icon: 'TrendingUp',
      },
    ],
  },
];

// Business-specific sidebar menu items
export const businessSidebarItems = [
  {
    key: 'business_games_and_packages',
    path: '/game-and-package',
    label: 'BUSINESS_SIDEBAR.MANAGE_GAME_AND_PACKAGE',
    is_under: false,
    icon: 'Source',
    permission: ['business_games_and_packages'],
    sub_menu: [],
  },
  {
    key: 'business_bank',
    path: '/bank-management',
    label: 'BUSINESS_SIDEBAR.BANK_MANAGEMENT',
    is_under: false,
    icon: 'AccountBalance',
    permission: ['business_bank'],
    sub_menu: [],
  },
  {
    key: 'business_cms',
    path: '/landing-page',
    label: 'BUSINESS_SIDEBAR.LANDING_PAGE',
    is_under: false,
    icon: 'Web',
    permission: ['business_cms'],
    sub_menu: [],
  },
  {
    key: 'business_topup_transactions_and_serial',
    path: '/business-topup',
    label: 'BUSINESS_SIDEBAR.TOPUP_TRANSACTION_SERIAL',
    is_under: false,
    icon: 'Gamepad',
    permission: ['business_topup_transactions_and_serial'],
    sub_menu: [],
  },
  {
    key: 'partner_api_keys',
    path: '/partner-api-keys',
    label: 'BUSINESS_SIDEBAR.PARTNER_API_KEYS',
    is_under: false,
    icon: 'VpnKey',
    permission: ['partner_api_keys'],
    sub_menu: [],
  },
  {
    key: 'business_customers',
    path: '/manage-customers',
    label: 'BUSINESS_SIDEBAR.MANAGE_CUSTOMERS',
    is_under: false,
    icon: 'People',
    permission: ['business_customers'],
    sub_menu: [],
  },
  {
    label: 'BUSINESS_SIDEBAR.CUSTOMER_DISCOUNTS.TITLE',
    icon: 'LocalOffer',
    permission: ['business_customer_discounts'],
    sub_menu: [
      {
        key: 'business_customer_discounts',
        path: '/customer-discounts',
        label: 'BUSINESS_SIDEBAR.CUSTOMER_DISCOUNTS.TIER_LIST',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'business_customer_discounts',
        path: '/customer-discounts/discount-configuration',
        label: 'BUSINESS_SIDEBAR.CUSTOMER_DISCOUNTS.DISCOUNT_CONFIGURATION',
        icon: 'SwapHorizontalCircle',
      },
    ],
  },
  {
    key: 'business_streamers',
    path: '/streamers',
    label: 'BUSINESS_SIDEBAR.STREAMER_MANAGEMENT',
    is_under: false,
    icon: 'Videocam',
    permission: ['business_streamers'],
    sub_menu: [],
  },
  {
    key: 'business_credit_transactions',
    path: '/business-credit-transaction',
    label: 'BUSINESS_SIDEBAR.CREDIT_TOPUP_TRANSACTION',
    is_under: false,
    icon: 'Ballot',
    permission: ['business_credit_transactions'],
    sub_menu: [],
  },
  {
    key: 'business_qr_monitor',
    path: '/business-qr-monitor',
    label: 'BUSINESS_SIDEBAR.QR_MONITOR',
    is_under: false,
    icon: 'Notifications',
    permission: ['business_qr_monitor'],
    sub_menu: [],
  },
  {
    key: 'business_reports',
    path: '/reports',
    label: 'SIDEBAR.REPORT',
    is_under: false,
    icon: 'ListAlt',
    permission: ['business_reports'],
    sub_menu: [
      {
        key: 'business_reports',
        path: '/reports',
        label: 'BUSINESS_SIDEBAR.REPORTS.TOPUP',
        icon: 'SwapHorizontalCircle',
      },
      {
        key: 'business_reports',
        path: '/reports/profit',
        label: 'BUSINESS_SIDEBAR.REPORTS.PROFIT',
        icon: 'TrendingUp',
      },
    ],
  },
  {
    key: 'business_employees',
    path: '/business/manage-accounts',
    label: 'SIDEBAR.MANAGE_ACCOUNTS',
    is_under: false,
    icon: 'PersonAdd',
    permission: ['business_employees'],
    sub_menu: [],
  },
  {
    key: 'business_storefront_template',
    path: '/storefront-template',
    label: 'BUSINESS_SIDEBAR.STOREFRONT_TEMPLATE',
    is_under: false,
    icon: 'Download',
    permission: ['business_storefront_template'],
    sub_menu: [],
  },
  {
    key: 'business_settings',
    path: '/business-settings',
    label: 'BUSINESS_SIDEBAR.SETTINGS',
    is_under: false,
    icon: 'Settings',
    permission: ['business_settings'],
    sub_menu: [],
  },
];

export function conditionPermission(useSelectUserPermission: any) {
  const nonPermissionKeys = nonPermissionSidebarItems.map((item) => item.key);

  if (useSelectUserPermission && useSelectUserPermission.length > 0) {
    const permission = useSelectUserPermission
      .map((item: any) => {
        if (`${item}.read`) {
          return `${item}.read`;
        }
        return false;
      })
      .filter(Boolean); // Remove false values

    const result = permission.includes('dashboard')
      ? permission
      : [...permission, 'dashboard'];

    return [...new Set([...result, ...nonPermissionKeys])];
  }

  return nonPermissionKeys;
}

// Business permission function - returns all business menu items
export function getBusinessPermissions() {
  const nonPermissionKeys = nonPermissionSidebarItems.map((item) => item.key);
  return [
    ...businessSidebarItems.map((item) => item.key),
    ...nonPermissionKeys,
  ];
}

export function getAdminPermissions() {
  const nonPermissionKeys = nonPermissionSidebarItems.map((item) => item.key);
  return [...staffSidebarItems.map((item) => item.key), ...nonPermissionKeys];
}

/**
 * Get permission key (without action) for a path. Use for table button checks (e.g. key.update, key.delete).
 * @param pathname - Current path (e.g. '/staff/manage-accounts')
 * @param isBusiness - Use business sidebar items if true
 * @returns Permission key like 'staff_users' or null if no match
 */
export function getPermissionKeyForPath(
  pathname: string,
  isBusiness = false
): string | null {
  const items = [
    ...(isBusiness ? businessSidebarItems : staffSidebarItems),
    ...nonPermissionSidebarItems,
  ];
  const path = pathname.replace(/\/$/, '') || '/';

  // Check sub_menu items first - match most specific (longest path) first
  for (const item of items) {
    if (item.sub_menu?.length) {
      const sortedSubItems = [...item.sub_menu].sort(
        (a, b) => (b.path?.length ?? 0) - (a.path?.length ?? 0)
      );
      for (const subItem of sortedSubItems) {
        if (path === subItem.path || path.startsWith(subItem.path + '/')) {
          return subItem.key || null;
        }
      }
    }
  }

  // Check parent items
  for (const item of items) {
    if (path === item.path || path.startsWith(item.path + '/')) {
      return item.key || null;
    }
  }

  return null;
}
